import usePhotos from "./usePhotos";
import useLocalStorage from "./useLocalStorage";

export { usePhotos, useLocalStorage };
